import { Loader } from "@/ui-components/Loader";
import * as React from "react";

/**
 * Inspired by https://github.com/getsentry/sentry/blob/master/static/app/makeLazyloadComponent.tsx
 */
export function makeLazyloadComponent<C extends React.ComponentType<any>>(resolve: () => Promise<{ default: C }>) {
  const LazyComponent = React.lazy(resolve);

  function RouteLazyLoad(props: React.ComponentProps<C>) {
    return (
      <React.Suspense fallback={<Loader />}>
        <LazyComponent {...props} />
      </React.Suspense>
    );
  }
  return RouteLazyLoad;
}
